<template>
  <div data-v-109a143a="" class="relative w-full">
    <header class="header" data-v-109a143a="">
      <div
        class="nav-inner flex justify-between items-center h-full mx-auto max-w-7xl"
        data-v-109a143a=""
      >
        <div
          class="flex items-center flex-none justify-center lg:justify-start lg:flex-1"
          data-v-109a143a=""
        >
          <a
            href="/"
            aria-current="page"
            aria-label="homeLink"
            class="brand-link nuxt-link-exact-active nuxt-link-active w-130px lg:w-210px"
            data-v-109a143a=""
          >
            <img
              alt="BAILYHANGA"
              class="baichenimg"
              src="@/assets/logo.png"
          /></a>
        </div>
        <a-menu :key="locale" mode="horizontal" theme="light">
          <head-nav-item
            v-for="route in displayRoutes"
            :key="`${locale}-${route.path}`"
            :route-obj="route"
          />
        </a-menu>
        <div class="flex items-center justify-end lg:flex-1" data-v-109a143a="">
          <div class="header-actions" data-v-109a143a="">
            <details ref="languageDetails" class="language-details" data-v-109a143a="">
              <summary class="language-trigger" data-v-109a143a="">
                <span class="language-icon" data-v-109a143a="">
                  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8" />
                    <path d="M3.5 12h17" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
                    <path
                      d="M12 3c2.7 2.6 4.2 5.8 4.2 9S14.7 18.4 12 21c-2.7-2.6-4.2-5.8-4.2-9S9.3 5.6 12 3Z"
                      stroke="currentColor"
                      stroke-width="1.8"
                    />
                  </svg>
                </span>
                <span data-v-109a143a="">{{ languageLabel }}</span>
              </summary>
              <div class="language-menu" data-v-109a143a="">
                <div
                  v-for="item in languages"
                  :key="item.value"
                  class="language-option"
                  :class="{ active: locale === item.value }"
                  role="button"
                  tabindex="0"
                  @mousedown.prevent="selectLanguage(item.value)"
                  @keydown.enter.prevent="selectLanguage(item.value)"
                  @keydown.space.prevent="selectLanguage(item.value)"
                  data-v-109a143a=""
                >
                  {{ item.label }}
                </div>
              </div>
            </details>

            <div class="desktop-buttons" data-v-109a143a="">
              <el-button plain @click="login()">{{ texts.login }}</el-button>
              <el-button type="primary" @click="gratis()">{{ texts.register }}</el-button>
            </div>
            <details ref="mobileDetails" class="mobile-menu">
              <summary class="mobile-menu-trigger" :aria-label="texts.menuLabel">
                <span></span><span></span>
              </summary>
              <nav class="mobile-menu-panel">
                <button
                  v-for="route in displayRoutes"
                  :key="`mobile-${locale}-${route.path}`"
                  @click="gotoMobile(route.path)"
                >
                  {{ route.desc || route.name }}
                </button>
                <button @click="login()">{{ texts.login }}</button>
                <button class="mobile-register" @click="gratis()">{{ texts.register }}</button>
              </nav>
            </details>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
// import store from '@/store'
import { mapGetters } from "vuex";
import HeadNavItem from "@/layout/head-nav/HeadNavItem";
import { localeState, setLocale } from "@/utils/locale";
// import { constantRoutes } from '@/router'

/**
 * 头部导航栏
 */
export default {
  name: "HeadNav",
  components: { HeadNavItem },
  data() {
    return {
      routeLabels: {
        zh: {
          Home: "首页",
          Product: "产品",
          price: "价格",
          Ad: "广告",
          AboutUs: "关于",
        },
        en: {
          Home: "Home",
          Product: "Product",
          price: "Pricing",
          Ad: "Advertising",
          AboutUs: "About",
        },
      },
      copy: {
        zh: {
          login: "登录",
          register: "注册",
          menuLabel: "打开导航菜单",
        },
        en: {
          login: "Sign in",
          register: "Sign up",
          menuLabel: "Open navigation menu",
        },
      },
      languages: [
        { value: "zh", label: "中文" },
        { value: "en", label: "English" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      routes: "routes/routes",
    }),
    locale() {
      return localeState.locale;
    },
    texts() {
      return this.copy[this.locale];
    },
    languageLabel() {
      return this.locale === "en" ? "English" : "中文";
    },
    displayRoutes() {
      return this.routes
        .filter((route) => !route.children && route.desc)
        .map((route) => ({
          ...route,
          desc:
            this.routeLabels[this.locale][route.name] ||
            this.routeLabels[this.locale][route.desc] ||
            route.desc,
        }));
    },
  },
  created() {
    // console.log('head-nav created ====> ', this.routes);
    // 路由初始化
    /*if (this.routes.length === 0) {
      store.dispatch(('routes/setRoutes'), constantRoutes);
    }*/
  },
  methods: {
    gotoMobile(path) {
      this.$router.push(path);
      if (this.$refs.mobileDetails) this.$refs.mobileDetails.removeAttribute("open");
    },
    /*gotoView(path){
      console.log('跳转 ===> ',path)
      this.$router.push(path)
    }*/
    login() {
      window.location.href =
        this.locale === "en"
          ? "mailto:keith.lu@hysenglobal.com?subject=Account%20Login%20Inquiry"
          : "mailto:keith.lu@hysenglobal.com?subject=%E8%B4%A6%E5%8F%B7%E7%99%BB%E5%BD%95%E5%92%A8%E8%AF%A2";
    },
    gratis() {
      window.location.href =
        this.locale === "en"
          ? "mailto:keith.lu@hysenglobal.com?subject=Account%20Registration%20Inquiry"
          : "mailto:keith.lu@hysenglobal.com?subject=%E8%B4%A6%E5%8F%B7%E6%B3%A8%E5%86%8C%E5%92%A8%E8%AF%A2";
    },
    selectLanguage(locale) {
      setLocale(locale);
      if (this.$refs.languageDetails) {
        this.$refs.languageDetails.removeAttribute("open");
      }
    },
  },
  mounted() {
    // const urlParams = new URLSearchParams(window.location.search);
    // console.log("123:"+window.location.search);
    
    // const code = urlParams.get('code');
    // if(code){
    //   window.location.href = `http://localhost?code=${code}`;
    // }
  },
};
</script>

<style scoped>
@media (min-width: 1024px) {
  .header[data-v-109a143a] {
    height: 4rem;
    padding-left: 0;
    padding-right: 0;
  }
}
@media (min-width: 1024px) {
  .lg\:flex-1 {
    flex: 1 1 0%;
  }
}
@media (min-width: 1024px) {
  .lg\:justify-start {
    justify-content: flex-start;
  }
}
.header[data-v-109a143a] {
  background: #fbfaf6;
  border-bottom: 1px solid #dddcd5;
  height: 4.5rem;
  padding-left: 15px;
  padding-right: 15px;
  position: sticky;
  top: 0;
  z-index: 50;
  box-shadow: none;
  transition: top 0.2s ease;
}
.ant-menu-horizontal {
  background: transparent;
  line-height: 54px;
  white-space: nowrap;
  border: 0;
  box-shadow: none;
}
.max-w-7xl {
  max-width: 80rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.h-full {
  height: 100%;
}
.justify-between {
  justify-content: space-between;
}
.items-center {
  align-items: center;
}
.flex {
  display: flex;
}
.baichenimg {
  display: block;
  height: auto;
  width: 90px;
}
.brand-link { display: inline-flex; }
.header-actions {
  align-items: center;
  display: flex;
  gap: 14px;
}
.desktop-buttons {
  display: flex;
  gap: 10px;
}
.language-details {
  position: relative;
}
.language-details[open] .language-trigger {
  background: rgba(37, 84, 254, 0.08);
}
.language-trigger {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 2px;
  color: #17352d;
  cursor: pointer;
  display: inline-flex;
  font-size: 14px;
  font-weight: 600;
  gap: 10px;
  min-height: 44px;
  padding: 10px 16px;
  position: relative;
  z-index: 121;
  list-style: none;
  user-select: none;
}
.language-trigger::-webkit-details-marker {
  display: none;
}
.language-trigger:hover {
  background: rgba(37, 84, 254, 0.06);
}
.language-icon {
  display: inline-flex;
  height: 20px;
  width: 20px;
}
.language-icon svg {
  height: 100%;
  width: 100%;
}
:deep(.language-dropdown-popper.el-popper) {
  display: none !important;
}
.language-menu {
  background: #fff;
  border: 1px solid rgba(36, 53, 88, 0.08);
  border-radius: 10px;
  box-shadow: 0 16px 38px rgba(45, 76, 156, 0.14);
  left: 50%;
  min-width: 210px;
  padding: 12px 0;
  position: absolute;
  top: calc(100% + 16px);
  transform: translateX(-50%);
  z-index: 130;
}
.language-menu::before {
  background: #fff;
  border-left: 1px solid rgba(36, 53, 88, 0.08);
  border-top: 1px solid rgba(36, 53, 88, 0.08);
  content: "";
  height: 16px;
  left: 50%;
  position: absolute;
  top: -9px;
  transform: translateX(-50%) rotate(45deg);
  width: 16px;
}
.language-option {
  background: transparent;
  border: 0;
  color: #20263d;
  cursor: pointer;
  display: block;
  font-size: 23px;
  font-weight: 500;
  line-height: 1.2;
  padding: 16px 32px;
  text-align: left;
  width: 100%;
}
.language-option.active {
  color: #b36b33;
  font-weight: 700;
}
.language-option:hover {
  background: rgba(37, 84, 254, 0.05);
}
.justify-end {
  justify-content: flex-end;
}
.items-center {
  align-items: center;
}
.w-full {
  width: 100%;
}
.relative {
  position: relative;
}
.desktop-buttons :deep(.el-button) {
  border-radius: 2px;
  min-height: 40px;
  padding: 0 19px;
}
.desktop-buttons :deep(.el-button--primary) {
  background: #17352d;
  border-color: #17352d;
}
.mobile-menu { display: none; position: relative; }
.mobile-menu-trigger {
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 6px;
  height: 42px;
  justify-content: center;
  list-style: none;
  width: 42px;
}
.mobile-menu-trigger::-webkit-details-marker { display: none; }
.mobile-menu-trigger span { background: #17352d; height: 1px; width: 22px; }
.mobile-menu-panel {
  background: #fbfaf6;
  border: 1px solid #dddcd5;
  box-shadow: 0 18px 38px rgba(23, 53, 45, 0.14);
  display: flex;
  flex-direction: column;
  min-width: 230px;
  padding: 10px;
  position: absolute;
  right: 0;
  top: 54px;
}
.mobile-menu-panel button {
  background: transparent;
  border: 0;
  color: #17352d;
  font-size: 15px;
  padding: 13px 14px;
  text-align: left;
}
.mobile-menu-panel .mobile-register { background: #17352d; color: #fff; }
@media (max-width: 1023px) {
  .header[data-v-109a143a] { height: 4rem; }
  .nav-inner > .ant-menu { display: none; }
  .desktop-buttons {
    display: none;
  }
  .mobile-menu { display: block; }
  .header-actions { gap: 2px; }
  .language-trigger { font-size: 13px; padding: 8px; }
  .language-icon { height: 18px; width: 18px; }
  .baichenimg { width: 105px; }
}
</style>
